(function () {
    'use strict';
    var m = angular.module('policy');
    m.directive('subMenu', ["path", "recursionHelper", "$timeout", "policyPropertyToNodes", "feature", "headerOptionsBuilder", "policyFilterTypes", "$rootScope", function (path, recursionHelper, $timeout, policyPropertyToNodes, feature, headerOptionsBuilder, policyFilterTypes, $rootScope) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('policy').directive('sub-menu').template(),
            scope: {
                menus: '=subMenu',
                menuId: '=',
                selectedId: '=',
                depth: '@',
                menuClicked: '&menuClicked',
                options: '=?',
                menuFilter: '=?',
                tempSelection: '=?'
            },
            compile: function (element) {
                return recursionHelper.compile(element, this.link);
            },
            link: function ($scope, element, attrs) {
                $scope.root = $scope;
                $scope.internal = {};
                $scope.options = $scope.options || {};
                $scope.options.blackList = $scope.options.blackList || [];
                $scope.menuFilter = undefined;
                $scope.keyWords = undefined;
                $scope.showAdvance = false;
                $scope.tempSelection = $scope.tempSelection || {};
                $scope.filterMode = 0;
                var generatedIds = [];
                var filteredMenus = [];
                var pointerCounts = {};
                var advancedFilter = $scope.options.hideAdvancedFilter;
                var menuFilter = '';
                var indexCount = 0;
                var limitOptions = {
                    menuFilterLimitCount: 200,
                    deepCount: 3
                };
                function isGroupMenu(nodeId) {
                    return $scope.menus[nodeId].groupMenu;
                }
                function makeSubMenuId(menuId, nodeId) {
                    if (_(nodeId).isObject()) {
                        return nodeId;
                    }
                    var id = _(nodeId.split('.')).last();
                    var fullId = _(menuId.fullId.split('.')).initial().join('.');
                    if (fullId) {
                        fullId += '.';
                    }
                    return {
                        id: id,
                        nodeId: nodeId,
                        fullId: fullId + nodeId
                    };
                }
                $timeout(function () {
                    $(element).find('.submenu-search input').focus();
                });
                $scope.$watch('menus', function () {
                    $scope.hoveredSubMenu = null;
                });
                $scope.singleMenuClickedWrapper = function (event, menuId, filter, inEditor) {
                    if (inEditor && !filter) {
                        event.stopPropagation();
                        return;
                    }
                    var menuIds = {};
                    menuIds[menuId.fullId] = true;
                    if ($scope.options.multiSelect) {
                        if ($scope.menus[menuId.nodeId].selectable) {
                            if (_($scope.tempSelection[menuId.fullId]).isUndefined()) {
                                $scope.tempSelection[menuId.fullId] = !_($scope.options.selectedList).contains(menuId.fullId);
                            } else {
                                $scope.tempSelection[menuId.fullId] = !$scope.tempSelection[menuId.fullId];
                            }
                            if ($scope.tempSelection[menuId.fullId] == _($scope.options.selectedList).contains(menuId.fullId)) {
                                delete $scope.tempSelection[menuId.fullId];
                            }
                        }
                    } else if (!inEditor) {
                        if ($scope.options.editor) {
                            var property = $scope.menus[menuId.nodeId];
                            var type = policyFilterTypes(property);
                            $scope.internal.filterOptions = headerOptionsBuilder($scope.options.editorOptions, property)[type];
                            $scope.internal.filter = $scope.options.getConditions(menuId);
                        } else if ($scope.menus[menuId.nodeId].selectable) {
                            $scope.menuClicked({
                                event: event,
                                menuIds: menuIds
                            });
                        }
                    } else {
                        $scope.menuClickedWrapper(event, menuIds, filter, inEditor);
                    }
                };
                $scope.menuClickedWrapper = function (event, menuIds, filter, inEditor) {
                    $scope.menuClicked({
                        event: event,
                        menuIds: menuIds,
                        filter: filter,
                        inEditor: inEditor
                    });
                };
                $scope.isTempSelected = function (menuId) {
                    return !_($scope.tempSelection[menuId.fullId]).isUndefined();
                };
                $scope.onApplyClick = function (event) {
                    $scope.menuClicked({
                        event: event,
                        menuIds: $scope.tempSelection
                    });
                };
                $scope.editorClick = function (event) {
                    if (event.target != $(element).find('.ok-button').get(0)) {
                        event.stopPropagation();
                    }
                };
                $scope.getMenuIconClass = function (menuId) {
                    var selected = false;
                    if (_($scope.tempSelection[menuId.fullId]).isUndefined()) {
                        selected = _($scope.options.selectedList).contains(menuId.fullId);
                    } else {
                        selected = $scope.tempSelection[menuId.fullId];
                    }
                    return selected ? $scope.options.menuIconSelected : $scope.options.menuIconUnselected;
                };
                $scope.isApplyActive = function () {
                    return _($scope.tempSelection).keys().length;
                };
                function isFinalNode(nodeId) {
                    var index = _($scope.menus[$scope.menuId.nodeId].sub).findIndex(function (node) {
                        return node === nodeId;
                    });
                    return index !== -1;
                }
                function isValidMenuItem(menuItem) {
                    if (!menuItem || !_(menuItem).isObject()) {
                        return false;
                    }
                    var validCount = 0;
                    var parsedFullId = menuItem.fullId.split('.');
                    if (parsedFullId.length >= 2) {
                        if ($scope.menus[$scope.menuId.nodeId] && $scope.menus[$scope.menuId.nodeId].sub && _($scope.menus[$scope.menuId.nodeId].sub).findIndex(function (subMenuId) {
                                return subMenuId === parsedFullId[0] + '.' + parsedFullId[1];
                            }) !== -1) {
                            _(parsedFullId).each(function (parsed, idx) {
                                if (idx + 2 < parsedFullId.length) {
                                    var compareId = parsed + '.' + parsedFullId[idx + 1];
                                    if ($scope.menus[compareId] && $scope.menus[compareId].sub && _($scope.menus[compareId].sub).findIndex(function (subMenuId) {
                                            return subMenuId === parsedFullId[idx + 1] + '.' + parsedFullId[idx + 2];
                                        }) !== -1) {
                                        validCount++;
                                    }
                                }
                            });
                        }
                    }
                    return validCount + 2 === parsedFullId.length;
                }
                function makeFilteredMenu(originMenu, nodeId, fullId, label, pointerCounts, deepCount) {
                    var nodes = nodeId.split('.'), pointers = _.clone(pointerCounts);
                    _(generatedIds).each(function (generatedId) {
                        if (indexCount > limitOptions.menuFilterLimitCount) {
                            return false;
                        }
                        if (typeof generatedId === 'string') {
                            var ids = generatedId.split('.');
                            if (ids[1] && ids[1] === nodes[0]) {
                                if (isFinalNode(generatedId) || deepCount >= limitOptions.deepCount) {
                                    var generatedMenuItem = {
                                        id: originMenu.id + '___' + indexCount,
                                        nodeId: originMenu.nodeId,
                                        fullId: ids[0] + '.' + fullId,
                                        label: $scope.menus[generatedId].label + ' / ' + label
                                    };
                                    if (isValidMenuItem(generatedMenuItem)) {
                                        filteredMenus.push(generatedMenuItem);
                                        indexCount++;
                                    }
                                } else {
                                    pointers[ids[0] + '.' + fullId + '___' + $scope.menus[generatedId].pointer] = pointers[fullId + '___' + $scope.menus[generatedId].pointer] || 0;
                                    if (fullId.indexOf(ids[0]) === -1 && pointers[ids[0] + '.' + fullId + '___' + $scope.menus[generatedId].pointer] + 1 < feature.policyPropertiesRecursionLimit) {
                                        pointers[ids[0] + '.' + fullId + '___' + $scope.menus[generatedId].pointer] = pointers[ids[0] + '.' + fullId + '___' + $scope.menus[generatedId].pointer] + 1;
                                        makeFilteredMenu(originMenu, generatedId, ids[0] + '.' + fullId, $scope.menus[generatedId].label + ' / ' + label, pointers, deepCount + 1);
                                    }
                                }
                            }
                        }
                    });
                }
                $scope.getSubMenus = function () {
                    if (!_($scope.menus).isUndefined()) {
                        var scroll = $scope.internal.scroll;
                        var maxLines = $scope.internal.maxLines;
                        var count = 0;
                        var idx = 0;
                        var menus = [];
                        var is_office365_emails = $scope.menuId.fullId == 'office365_emails_email';
                        if ($scope.menuFilter) {
                            if ($scope.menuFilter !== menuFilter) {
                                filteredMenus = [];
                                indexCount = 0;
                                _($scope.allSubMenus).each(function (nodeId) {
                                    if (_(nodeId).isString()) {
                                        var menu = makeSubMenuId($scope.menuId, nodeId);
                                        pointerCounts = {};
                                        if (isFinalNode(menu.nodeId)) {
                                            filteredMenus.push({
                                                id: menu.id + '___' + indexCount,
                                                nodeId: menu.nodeId,
                                                fullId: menu.fullId,
                                                label: $scope.menus[nodeId].label
                                            });
                                            indexCount++;
                                        }
                                        makeFilteredMenu(menu, menu.nodeId, menu.fullId, $scope.menus[nodeId].label, pointerCounts, indexCount, 0);
                                    }
                                });
                                $scope.options.hideAdvancedFilter = true;
                                var temp = _.chain(filteredMenus).sortBy('label').groupBy(function (menu) {
                                    var arr = menu.label.split('/');
                                    return arr[0];
                                }).map(function (val, key) {
                                    return _(val).sortBy(function (m) {
                                        return m.label.length;
                                    });
                                }).value();
                                filteredMenus = [];
                                _(temp).each(function (menuGroup) {
                                    filteredMenus = _.union(filteredMenus, menuGroup);
                                });
                                menuFilter = $scope.menuFilter;
                            }
                            if ($rootScope.usingNewPolicyMenu && is_office365_emails) {
                                menus = filteredMenus;
                            } else {
                                menus = _(filteredMenus).reduce(function (memo, menu) {
                                    if (idx >= scroll && count < maxLines) {
                                        memo.push(menu);
                                        count++;
                                    }
                                    idx++;
                                    return memo;
                                }, []);
                            }
                        } else {
                            if ($rootScope.usingNewPolicyMenu && is_office365_emails) {
                                menus = $scope.allSubMenus;
                            } else {
                                menus = _($scope.allSubMenus).reduce(function (memo, menu) {
                                    if (idx >= scroll && count < maxLines) {
                                        memo.push(menu);
                                        if (_(menu).isString()) {
                                            count++;
                                        }
                                    }
                                    if (_(menu).isString()) {
                                        idx++;
                                    }
                                    return memo;
                                }, []);
                            }
                            while (_(_(menus).last()).isObject()) {
                                menus = _(menus).initial();
                            }
                            menus = _(menus).map(function (nodeId) {
                                return makeSubMenuId($scope.menuId, nodeId);
                            });
                            $scope.options.hideAdvancedFilter = advancedFilter;
                            if ($rootScope.usingNewPolicyMenu && is_office365_emails) {
                                menus = orderMenus(menus);
                            }
                        }
                        return menus;
                    }
                };
                function orderMenus(menus) {
                    var orderedMenus = [];
                    var menusMapping = [
                        'HasAttachments',
                        'ReceivedDateTime',
                        'is_deleted_message',
                        'office365_emails_attachment:message_id(id)',
                        'DisplayName',
                        'incoming',
                        'internal_mail',
                        'InternetMessageId',
                        'geo_resolve:ip(x_originating_ip)',
                        'is_quarantined',
                        'recipients',
                        'ReplyTo',
                        'ReplyToNickname',
                        'is_restored_from_quarantine',
                        'office365_emails_email~Security Stack',
                        'office365_emails_user:id(Sender)',
                        'sender_ip',
                        'scl',
                        'spf_check_result',
                        'Subject'
                    ];
                    // starting by pushing in the menusMapping order
                    menusMapping.forEach(function (menuId) {
                        var menu = menus.find(function (_menu) {
                            return _menu.id == menuId;
                        });
                        if (menu) {
                            orderedMenus.push(menu);
                        }
                    });
                    return orderedMenus;
                }
                $scope.isScrollUpEnabled = function () {
                    if (!_($scope.menus).isUndefined()) {
                        return $scope.internal.scroll > 0;
                    }
                };
                function filterMenus(menu) {
                    return _(menu).isString();
                }
                function isBackRef(baseNodeId, nodeId) {
                    if (!baseNodeId || !nodeId) {
                        return false;
                    }
                    var re = /^(\w+)(?::[\w)(]+)?\.(\w+):(\w+)\((\w+)\)$/;
                    /*
                 Parses string 'office365_emails_membership:user_id(id).office365_emails_group:id(group_member_id)'
                 to array ['...source...', 'office365_emails_membership', 'office365_emails_group', 'id',  'group_member_id']
                 */
                    var nodeInfo = re.exec(nodeId);
                    if (!nodeInfo || nodeInfo.length !== 5) {
                        return false;
                    }
                    var baseInfo = re.exec(baseNodeId);
                    if (!baseInfo || baseInfo.length !== 5) {
                        return false;
                    }
                    if (nodeInfo[1] === baseInfo[2] && nodeInfo[2] === baseInfo[1] && nodeInfo[3] === baseInfo[4] && nodeInfo[4] === baseInfo[3]) {
                        return true;
                    }
                    return false;
                }
                function filterVisibleMenus(menuId, menuFilter) {
                    return function filterVisibleMenus(subId) {
                        if ($scope.depth === 0 && $scope.menus[subId].sub) {
                            return false;
                        }
                        if (isBackRef(menuId.nodeId, subId)) {
                            return false;
                        }
                        var menu = $scope.menus[subId];
                        if (!menu) {
                            return false;
                        }
                        if (menuFilter) {
                            if (!menu.label) {
                                return false;
                            }
                            var filterIndex = menu.label.toLowerCase().indexOf(menuFilter.toLowerCase());
                            if (filterIndex == -1) {
                                return false;
                            }
                        }
                        $scope.ignore[menu.pointer] = $scope.ignore[menu.pointer] || 0;
                        if ($scope.ignore[menu.pointer] >= feature.policyPropertiesRecursionLimit) {
                            return false;
                        }
                        if (!$scope.showAdvance) {
                            var isRoot = menuId.nodeId === 0 || isGroupMenu(menuId.nodeId) && menuId.fullId.indexOf('.') == -1;
                            if (isRoot && menu.advanceProperty) {
                                return false;
                            }
                            if (!isRoot && menu.advancePointer || menu.advanceProperty) {
                                return false;
                            }
                        }
                        if (menuId.nodeId === 0) {
                            return true;
                        }
                        if (_($scope.options.blackList).contains(menuId.fullId + '.' + _(subId.split('.')).last())) {
                            return false;
                        }
                        if (_(subId).isObject()) {
                            return !subId.onlyOnRoot;
                        }
                        return !menu.onlyOnRoot;
                    };
                }
                $scope.isScrollDownEnabled = function () {
                    if (!_($scope.menus).isUndefined()) {
                        if ($scope.menuFilter) {
                            return filteredMenus.length > $scope.internal.scroll + $scope.internal.maxLines;
                        } else {
                            return _($scope.allSubMenus).filter(filterMenus).length > $scope.internal.scroll + $scope.internal.maxLines;
                        }
                    }
                };
                $scope.onWheel = function (event, delta) {
                    if ($scope.internal.maxLines < Number.MAX_VALUE) {
                        event.preventDefault();
                        event.stopPropagation();
                        $scope.processScroll(delta);
                    }
                };
                $scope.onScrollClick = function (event, delta) {
                    $scope.processScroll(delta);
                    event.preventDefault();
                    event.stopPropagation();    //$scope.menuClicked({event: event, menuId: {}});
                };
                $scope.processScroll = function (delta) {
                    $scope.hoveredSubMenu = null;
                    var prevScroll = $scope.internal.scroll;
                    $scope.internal.scroll -= delta;
                    if ($scope.menuFilter) {
                        $scope.internal.scroll = Math.min(filteredMenus.length - $scope.internal.maxLines, $scope.internal.scroll);
                    } else {
                        $scope.internal.scroll = Math.min(_($scope.allSubMenus).filter(filterMenus).length - $scope.internal.maxLines, $scope.internal.scroll);
                    }
                    $scope.internal.scroll = Math.max(0, $scope.internal.scroll);
                    if ($scope.internal.scroll != prevScroll) {
                        $(element).find('.submenu-menus > a').each(function () {
                            $(this).blur();
                        });
                    }
                    $scope.subMenus = $scope.getSubMenus();
                };
                $scope.getTopForMenu = function (index) {
                    var submenu = $scope.menus[$scope.subMenus[index].nodeId];
                    if (_(submenu.sub).isUndefined()) {
                        return 0;
                    }
                    var submenuHeight = Math.min(_(submenu.sub).chain().filter(function (subId) {
                        return !($scope.depth == 1 && $scope.menus[subId].sub);
                    }).filter(filterMenus).filter(function (subId) {
                        return filterVisibleMenus($scope.subMenus[index], $scope.internal.subMenuFilter)(subId);
                    }).value().length - 1, $scope.internal.maxLines);
                    var realIndex = 0;
                    for (var i = 0; i < index; i++) {
                        if (_($scope.subMenus[i].id).isString()) {
                            realIndex++;
                        }
                    }
                    return -((Math.min(submenuHeight, realIndex) + 1) * 100) + '%';
                };
                $scope.isSelectedPath = function (menu) {
                    return $scope.selectedId && _($scope.selectedId.fullId).isString() && $scope.selectedId.fullId.indexOf(menu.fullId) === 0;
                };
                $scope.getSubSelected = function () {
                    if (_($scope.selectedId).isUndefined()) {
                        return undefined;
                    }
                    var dot = $scope.selectedId.indexOf('.');
                    if (~dot) {
                        return undefined;
                    }
                    return $scope.selectedId.slice(dot + 1);
                };
                $scope.clearFilter = function () {
                    $scope.keyWords = '';
                };
                $scope.setAdvance = function (event, newAdvance) {
                    $scope.showAdvance = newAdvance;
                    event.preventDefault();
                    event.stopPropagation();
                };
                function recurringGenerator(newlist, mainlist, menu) {
                    var subList = [];
                    _(newlist).each(function (subId) {
                        if (menu[subId] && menu[subId].sub) {
                            subList = _(subList).union(_(menu[subId].sub).filter(function (subSubId) {
                                return !isBackRef(subId, subSubId);
                            }));
                        }
                    });
                    subList = _.difference(subList, mainlist);
                    if (_.isEmpty(subList)) {
                        generatedIds = _.clone(mainlist);
                    } else {
                        mainlist = mainlist.concat(subList);
                        recurringGenerator(subList, mainlist, menu);
                    }
                }
                function generateMenuList(menu, id) {
                    recurringGenerator(menu[id].sub, menu[id].sub, menu);
                }
                // don't show empty submenus and its'parent.
                function getShowableSubMenus(allSubMenus, hideAdvancedFilter) {
                    return _(allSubMenus).reject(function (subMenuId) {
                        if ($scope.menus[subMenuId] && $scope.menus[subMenuId].sub) {
                            if ($scope.menus[subMenuId].sub.length) {
                                if (hideAdvancedFilter) {
                                    var normalSubMenus = _($scope.menus[subMenuId].sub).reject(function (sub) {
                                        return $scope.menus[sub].advancePointer;
                                    });
                                    return !(normalSubMenus && normalSubMenus.length);
                                }
                                return false;
                            }
                            return true;
                        }
                        return false;
                    });
                }
                function init() {
                    if ($rootScope.usingNewPolicyMenu) {
                        $scope.menus['office365_emails_email.office365_emails_folder:id(folder_id).DisplayName'] = {
                            id: 'office365_emails_email.office365_emails_folder:id(folder_id).DisplayName',
                            entityName: 'office365_emails_email',
                            name: 'office365_emails_email.office365_emails_folder:id(folder_id).DisplayName',
                            label: 'Folder path',
                            description: 'folder path',
                            selectable: true,
                            type: 'TEXT',
                            originType: 'TEXT',
                            mainIdentifier: 'office365_emails_email.office365_emails_folder:id(folder_id).DisplayName',
                            showInCondition: true,
                            showInExcludeBy: true,
                            defaultValue: '',
                            allowContains: true,
                            policyMenu: true
                        };
                    }
                    var menus = $scope.menus;
                    $scope.hoveredSubMenu = null;
                    $scope.internal = {
                        maxLines: 18,
                        //Number.MAX_VALUE,
                        scroll: 0
                    };
                    if (_(menus).isUndefined()) {
                        return;
                    }
                    $scope.ignore = {};
                    if ($scope.menuId.id && !feature.propertiesRecursion) {
                        var addNodeToIgnore = function (nodeId) {
                            $scope.ignore[nodeId] = ($scope.ignore[nodeId] || 0) + 1;
                        };
                        var nodes = policyPropertyToNodes($scope.menuId.fullId);
                        _(nodes).chain().map(function (nodeId) {
                            if (!$scope.menus[nodeId]) {
                                return null;
                            }
                            return $scope.menus[nodeId].entityName;
                        }).filter(_.isString).each(addNodeToIgnore);
                        var lastNode = _(nodes).last();
                        if ($scope.menus[lastNode] && $scope.menus[lastNode].pointer) {
                            addNodeToIgnore($scope.menus[lastNode].pointer);
                        }
                    }
                    if ($scope.menuId.nodeId) {
                        $scope.filterMode = 0;    // if you want to disable advanced filtering from second dropdown, please change this number to 1.
                    }
                    var allSubMenus = [];
                    if ($scope.filterMode) {
                        allSubMenus = _($scope.menus[$scope.menuId.nodeId].sub).filter(filterVisibleMenus($scope.menuId, $scope.menuFilter));
                    } else {
                        generateMenuList($scope.menus, $scope.menuId.nodeId);
                        allSubMenus = _($scope.menuFilter ? generatedIds : $scope.menus[$scope.menuId.nodeId].sub).filter(filterVisibleMenus($scope.menuId, $scope.menuFilter));
                    }
                    $scope.allSubMenus = getShowableSubMenus(allSubMenus, advancedFilter);
                    $scope.subMenus = $scope.getSubMenus();
                    if (feature.sonicwallTheme) {
                        var subMenuTitle = $scope.menus[$scope.menuId.nodeId].pointerLabel;
                        if (subMenuTitle && subMenuTitle.indexOf('GTB') !== -1) {
                            $scope.menus[$scope.menuId.nodeId].pointerLabel = subMenuTitle.replace('GTB', '');
                        }
                    }
                    $scope.title = $scope.menus[$scope.menuId.nodeId].pointerLabel;
                }
                function initWatch(newVal, oldVal) {
                    if (oldVal == newVal) {
                        return;
                    }
                    init();
                }
                var lazyFilter = _.debounce(function (newVal, oldVal) {
                    if (oldVal == newVal) {
                        return;
                    }
                    $scope.menuFilter = newVal;
                    init();
                }, 1000);
                $scope.$watch('menus', initWatch);
                $scope.$watch('keyWords', lazyFilter);
                $scope.$watch('showAdvance', initWatch);
                init();
                var keys = {
                    left: 37,
                    right: 39,
                    up: 38,
                    down: 40
                };
                function processKeys(e) {
                    var processed = false;
                    if (e.keyCode == keys.down && $(element).find('.submenu-search input').is(':focus')) {
                        $(element).find('.submenu-menus:first > a').focus();
                        processed = true;
                    } else {
                        var focusedIdx = -1;
                        var submenus = $(element).find('.submenu-menus > a');
                        submenus.each(function (idx, el) {
                            if ($(el).is(':focus')) {
                                focusedIdx = idx;
                            }
                        });
                        processed = true;
                        if (e.keyCode == keys.left && _($scope.hoveredSubMenu).isNumber()) {
                            $timeout(function () {
                                submenus[$scope.hoveredSubMenu].focus();
                                $scope.hoveredSubMenu = undefined;
                            });
                        } else if (focusedIdx < 0) {
                            processed = false;
                        } else if (e.keyCode == keys.up && focusedIdx === 0) {
                            $timeout(function () {
                                $(element).find('.submenu-search input').focus();
                            });
                        } else if (e.keyCode == keys.up) {
                            $timeout(function () {
                                submenus[focusedIdx - 1].focus();
                            });
                        } else if (e.keyCode == keys.down) {
                            $timeout(function () {
                                if (submenus.length > focusedIdx + 1) {
                                    submenus[focusedIdx + 1].focus();
                                }
                            });
                        } else if (e.keyCode == keys.right) {
                            if ($scope.menus[$scope.subMenus[focusedIdx].nodeId].sub) {
                                $timeout(function () {
                                    $scope.hoveredSubMenu = focusedIdx;
                                });
                            }
                        } else {
                            processed = false;
                        }
                    }
                    if (processed) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
                $(element).on('keydown', processKeys);
                $scope.$on('$destroy', function () {
                    $(element).off('keydown', processKeys);
                });
            }
        };
    }]);
}());